import React, { useState } from 'react';
import { resendDocuments } from '../../services/ResubmissionService';

const DOCS = [
  { key: 'identification',          label: 'Documento de identificação' },
  { key: 'selfie',                  label: 'Selfie' },
  { key: 'address_proof',           label: 'Comprovante de endereço' },
  { key: 'balance_sheet',           label: 'Balanço' },
  { key: 'social_contract',         label: 'Contrato social' },
  { key: 'additional_document_one', label: 'Documento adicional 1' },
  { key: 'additional_document_two', label: 'Documento adicional 2' },
];

const MAX_MB = 10;
const ACCEPTED = ['image/jpeg', 'image/png', 'application/pdf'];

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = (e) => resolve(String(e.target.result).split(',')[1]);
    r.onerror = reject;
    r.readAsDataURL(file);
  });

export default function ResubmissionsPage() {
  const [email, setEmail] = useState('');
  const [files, setFiles] = useState({});
  const [errors, setErrors] = useState({});
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [errorMsg, setErrorMsg] = useState('');

  function onPick(key, file) {
    const nextErr = { ...errors };
    if (file) {
      if (!ACCEPTED.includes(file.type)) nextErr[key] = 'Formato não permitido (JPG/PNG/PDF).';
      else if (file.size > MAX_MB * 1024 * 1024) nextErr[key] = `Arquivo muito grande (máx. ${MAX_MB}MB).`;
      else delete nextErr[key];
      setFiles((prev) => ({ ...prev, [key]: file }));
    } else {
      delete nextErr[key];
      const { [key]: _, ...rest } = files;
      setFiles(rest);
    }
    setErrors(nextErr);
  }

  async function onSubmit(e) {
    e.preventDefault();
    setErrorMsg('');
    if (!email.trim()) {
      setErrorMsg('Informe o e-mail.');
      return;
    }
    if (Object.values(errors).length) {
      setErrorMsg('Há erros nos arquivos selecionados.');
      return;
    }
    const selected = Object.entries(files).filter(([, f]) => !!f);
    if (selected.length === 0) {
      setErrorMsg('Envie pelo menos um documento.');
      return;
    }

    setBusy(true); setResult(null);
    try {
      const base64Map = {};
      for (const [k, f] of selected) base64Map[k] = await toBase64(f);
      const res = await resendDocuments(email.trim(), base64Map);
      setResult(res);
    } catch (err) {
      console.error(err);
      setErrorMsg('Não foi possível reenviar. Verifique os arquivos e tente novamente.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <section style={{ padding: 20, maxWidth: 760, margin: '0 auto' }}>
      <h1 style={{ fontSize: 22, fontWeight: 'bold', marginBottom: 12, textAlign: 'center' }}>
        Reenvio de documentos recusados
      </h1>
      <p style={{ marginBottom: 16, textAlign: 'center' }}>
        Envie os arquivos (JPG, PNG ou PDF). Eles serão enviados em <b>base64</b> no campo <code>files</code> junto com o <code>email</code>.
      </p>

      <form onSubmit={onSubmit} style={{ display: 'grid', gap: 12, maxWidth: 520, margin: '0 auto' }}>
        <div style={{ display: 'grid', gap: 6 }}>
          <label style={{ fontWeight: 600 }}>E-mail do usuário</label>
          <input
            type="email"
            required
            placeholder="usuario@exemplo.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{
              padding: '10px 12px',
              borderRadius: 8,
              border: '1px solid #e5e7eb',
              outline: 'none',
            }}
          />
        </div>

        {DOCS.map(({ key, label }) => (
          <div key={key} style={{ display: 'grid', gap: 6 }}>
            <label style={{ fontWeight: 600 }}>{label}</label>
            <input
              type="file"
              accept=".jpg,.jpeg,.png,.pdf"
              onChange={(e) => onPick(key, e.target.files?.[0])}
            />
            {files[key] && (
              <div style={{ fontSize: 13, color: '#555' }}>
                Selecionado: <b>{files[key].name}</b> ({Math.round(files[key].size / 1024)} KB)
              </div>
            )}
            {errors[key] && <div style={{ color: 'crimson', fontSize: 13 }}>{errors[key]}</div>}
          </div>
        ))}

        {errorMsg && <div style={{ color: 'crimson' }}>{errorMsg}</div>}

        <div style={{ display: 'flex', gap: 12, marginTop: 12, justifyContent: 'center' }}>
          <button
            type="submit"
            disabled={busy}
            style={{
              padding: '10px 16px',
              borderRadius: 8,
              background: '#00E52E',
              color: '#000',
              fontWeight: 700,
              border: 0,
              cursor: 'pointer',
              opacity: busy ? .6 : 1
            }}
          >
            {busy ? 'Reenviando...' : 'Reenviar documentos'}
          </button>
          <button
            type="button"
            onClick={() => { setFiles({}); setErrors({}); setResult(null); setEmail(''); setErrorMsg(''); }}
            style={{
              padding: '10px 16px',
              borderRadius: 8,
              background: '#EBEBED',
              color: '#111',
              fontWeight: 600,
              border: 0,
              cursor: 'pointer'
            }}
          >
            Limpar
          </button>
        </div>
      </form>

      {result && (
        <div style={{ marginTop: 24 }}>
          <h2 style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 8, textAlign: 'center' }}>Resultado</h2>
          <pre style={{ background: '#f8f9fb', padding: 12, borderRadius: 8, overflowX: 'auto' }}>
            {JSON.stringify(result, null, 2)}
          </pre>
        </div>
      )}
    </section>
  );
}






